import { api } from '@/lib/api'
import type {
  CreateFeatureFlagRequest,
  FeatureFlagDTO,
  FeatureFlagKey,
  FeatureFlagRule,
} from '@/schemas/feature-flag.schema'

export async function getFeatureFlags() {
  const items: FeatureFlagDTO[] = []
  for (let offset = 0; ; offset += 100) {
    const response = await api.getPaginated<FeatureFlagDTO>(
      `/admin/feature-flags?limit=100&offset=${offset}`,
    )
    items.push(...response.data)
    if (!response.pagination?.hasMore || response.data.length === 0) {
      break
    }
  }
  return { items }
}
export function createFeatureFlag(input: CreateFeatureFlagRequest) {
  return api.post<FeatureFlagDTO>('/admin/feature-flags', input)
}
export function updateFeatureFlag(key: FeatureFlagKey, rule: FeatureFlagRule) {
  return api.put<FeatureFlagDTO>(
    `/admin/feature-flags/${encodeURIComponent(key)}`,
    {
      audience: rule.audience,
      whitelist: rule.whitelist,
    },
  )
}
// A soft delete in the API: the key stays taken, and code that still reads
// it gets the flag as off.
export function deleteFeatureFlag(key: FeatureFlagKey) {
  return api.delete<FeatureFlagDTO>(
    `/admin/feature-flags/${encodeURIComponent(key)}`,
  )
}
